// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "network.dgg",
    name: "DGG Wallet",
    homepage: "https://dgg.network",
    image_id: "e4cbed08-8839-4bce-875f-d8917ceb7e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/nl/app/dgg-wallet-nfts-games/id1659618218",
        android: "https://play.google.com/store/apps/details?id=network.dgg.wallet&hl=en_US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://apps.apple.com/nl/app/dgg-wallet-nfts-games/id1659618218",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "dgg://",
        universal: "https://dggnetwork.app.link",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map